import { render, staticRenderFns } from "./chat-window-item-user.vue?vue&type=template&id=e40004d4&scoped=true&"
import script from "./chat-window-item-user.vue?vue&type=script&lang=js&"
export * from "./chat-window-item-user.vue?vue&type=script&lang=js&"
import style0 from "./chat-window-item-user.vue?vue&type=style&index=0&id=e40004d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e40004d4",
  null
  
)

export default component.exports